import { Location } from 'react-router-dom';

import { parse, stringify } from 'utils/query';

export const parseRedirectLink = (location: Location | null): string | null => {
  if (location) {
    const search = parse(location.search);
    return search.redirectTo ? window.atob(search.redirectTo as string) : null;
  }
  return null;
};

export const getRedirectLink = (location: Location) => {
  const link = `${location.pathname || ''}${location.search || ''}`;
  const redirectLink = link && link !== '/' ? stringify({ redirectTo: window.btoa(link) }) : '';

  return redirectLink ? `?${redirectLink}` : '';
};
